import Table from './ant';

export default Table;
